/*
  Card buy row + clickable colour dots (PDP LAB 20 Sep 2026). Markup: snippets/kn-card-buy.liquid.
  - a colour dot switches the card's photo, its links (?variant=) and its size row;
  - a size chip adds that exact variant and opens the theme's cart drawer.
  One delegated listener, so it covers every grid, including rows Dawn re-renders from a fetch.
*/
(() => {
  const dataOf = (card) => {
    if (card.__kcb) return card.__kcb;
    const s = card.querySelector('[data-kcb-data]');
    if (!s) return null;
    try { card.__kcb = JSON.parse(s.textContent); } catch (e) { return null; }
    return card.__kcb;
  };
  const cardOf = (el) => el.closest('.card-wrapper');

  const paintColour = (card, name) => {
    const D = dataOf(card); if (!D) return;
    const c = D.colours[name]; if (!c) return;
    const box = card.querySelector('[data-kcb]');
    box.dataset.colour = name;
    // photo
    const imgs = card.querySelectorAll('.card__media .media img');
    if (imgs[0]) { imgs[0].src = c.img; if (c.srcset) imgs[0].srcset = c.srcset; else imgs[0].removeAttribute('srcset'); }
    // Dawn fades the first photo out on hover to show the second, so the second must change too
    if (imgs[1]) { imgs[1].src = c.back || c.img; imgs[1].removeAttribute('srcset'); }
    // links follow the colour
    const url = c.first ? `${D.url}?variant=${c.first}` : D.url;
    card.querySelectorAll('a[href*="/products/"]').forEach((a) => { a.href = url; });
    // dots
    card.querySelectorAll('[data-kcb-colour]').forEach((d) => d.setAttribute('aria-checked', d.dataset.kcbColour === name ? 'true' : 'false'));
    // size row
    const row = card.querySelector('[data-kcb-row]');
    const label = card.querySelector('[data-kcb-label]');
    if (label) label.textContent = `Add · ${name}`;
    if (row && D.sizes.length) {
      row.innerHTML = D.sizes.map((sz) => {
        const v = c.variants[sz];
        return v && v.av
          ? `<button type="button" class="kcb__chip" data-kcb-add="${v.id}" aria-label="Add size ${sz}">${sz}</button>`
          : `<span class="kcb__chip is-out" aria-label="Size ${sz} sold out">${sz}</span>`;
      }).join('');
    } else if (row && c.first) {
      row.innerHTML = `<button type="button" class="kcb__chip kcb__chip--wide" data-kcb-add="${c.first}">Add to bag</button>`;
    }
    paintStock(card, c);
  };
  // "Only 2 left in M": the lowest real count among the sizes on offer, only when 4 or fewer
  const paintStock = (card, c) => {
    const el = card.querySelector('[data-kcb-stock]'); if (!el) return;
    const low = Object.entries(c.variants).filter(([k, v]) => k !== '_' && v && v.av && v.q > 0).sort((a, b) => a[1].q - b[1].q)[0];
    if (!low) { el.hidden = true; return; }
    el.textContent = `Only ${low[1].q} left${low[0] === 'One size' ? '' : ` in ${low[0]}`}`;
    el.hidden = false;
  };

  const add = async (id) => {
    const drawer = document.querySelector('cart-drawer');
    const fd = new FormData();
    fd.append('id', id); fd.append('quantity', 1);
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
      fd.append('sections_url', location.pathname);
    }
    // /cart/add.js with no Accept header on purpose: posting to /cart/add with
    // "Accept: application/javascript" makes Shopify drop a Bundles-app set that is
    // already in the cart (reproduced on LAB and LIVE, 20 Sep 2026).
    const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
    const json = await res.json();
    if (json.status) throw new Error(json.description || 'Could not add');
    if (drawer && drawer.renderContents) drawer.renderContents(json);
    else location.href = window.routes?.cart_url || '/cart';
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kn-card-buy', productVariantId: id, cartData: json }); } catch (e) {}
    }
    return json;
  };

  document.addEventListener('click', async (e) => {
    const dot = e.target.closest('[data-kcb-colour]');
    if (dot) {
      const card = cardOf(dot); if (!card || !dataOf(card)) return;
      e.preventDefault(); e.stopPropagation();
      paintColour(card, dot.dataset.kcbColour);
      return;
    }
    const chip = e.target.closest('[data-kcb-add]');
    if (chip) {
      e.preventDefault(); e.stopPropagation();
      if (chip.classList.contains('is-busy')) return;
      const card = cardOf(chip);
      chip.classList.add('is-busy');
      try {
        await add(chip.dataset.kcbAdd);
        chip.classList.remove('is-busy'); chip.classList.add('is-done');
        if (card) { card.classList.add('is-added'); setTimeout(() => card.classList.remove('is-added'), 2000); }
        setTimeout(() => chip.classList.remove('is-done'), 1500);
      } catch (err) {
        chip.classList.remove('is-busy'); chip.title = err.message;
      }
      return;
    }
  }, true);

  // mark the current colour's dot on load
  const init = (root = document) => {
    root.querySelectorAll('.card-wrapper [data-kcb]').forEach((box) => {
      const card = cardOf(box); const name = box.dataset.colour;
      card.querySelectorAll('[data-kcb-colour]').forEach((d) => d.setAttribute('aria-checked', d.dataset.kcbColour === name ? 'true' : 'false'));
      const D = dataOf(card);
      if (D && D.colours[name] && !box.dataset.stocked) {
        box.dataset.stocked = '1';
        paintStock(card, D.colours[name]);
        // the card's links open the product in the colour the card is showing
        const c = D.colours[name];
        if (c.first) card.querySelectorAll('a[href*="/products/"]').forEach((a) => { if (!/[?&]variant=/.test(a.getAttribute('href') || '')) a.href = `${D.url}?variant=${c.first}`; });
      }
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  new MutationObserver(() => init()).observe(document.documentElement, { childList: true, subtree: true });
})();
